import { i18n } from '../utils/i18n'

export enum PlayerMouseWheelScrollSensitivity {
    VERY_SLOW = 'very_slow',
    SLOW = 'slow',
    NORMAL = 'normal',
    FAST = 'fast',
    VERY_FAST = 'very_fast',
}

export const playerMouseWheelScrollSensitivityLabel = (
    sensitivity: PlayerMouseWheelScrollSensitivity
): string => {
    switch (sensitivity) {
        case PlayerMouseWheelScrollSensitivity.VERY_SLOW:
            return i18n.t('common.label.verySlow')
        case PlayerMouseWheelScrollSensitivity.SLOW:
            return i18n.t('common.label.slow')
        case PlayerMouseWheelScrollSensitivity.NORMAL:
            return i18n.t('common.label.normal')
        case PlayerMouseWheelScrollSensitivity.FAST:
            return i18n.t('common.label.fast')
        case PlayerMouseWheelScrollSensitivity.VERY_FAST:
            return i18n.t('common.label.veryFast')
        default:
            throw new Error(`Unknown scroll sensitivity: ${sensitivity}`)
    }
}

export const playerMouseWheelScrollSensitivityEventsMultiplier = (
    sensitivity: PlayerMouseWheelScrollSensitivity
): number => {
    switch (sensitivity) {
        case PlayerMouseWheelScrollSensitivity.VERY_SLOW:
            return 0.25
        case PlayerMouseWheelScrollSensitivity.SLOW:
            return 0.5
        case PlayerMouseWheelScrollSensitivity.NORMAL:
            return 1
        case PlayerMouseWheelScrollSensitivity.FAST:
            return 2
        case PlayerMouseWheelScrollSensitivity.VERY_FAST:
            return 3
        default:
            throw new Error(`Unknown scroll sensitivity: ${sensitivity}`)
    }
}
